import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUnlockAlt, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faGithub, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { Col, Row, Form, Card, Button, FormCheck, Container, InputGroup } from '@themesberg/react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Routes } from "../../routes";
import BgImage from "../../assets/img/illustrations/signin2.svg";
import { useAuth } from "../../AuthContext";
import AxiosInstance from "../../AxiosInstance";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await AxiosInstance.post("/api/users/login", {
        email,
        password,
      });

      const user = response?.data?.user;
      if (user?.role === "superAdmin") {
        login(user);
        navigate("/profil");
      } else {
        setError("Email ou mot de passe incorrect.");
      }
    } catch (err) {
      if (err.response?.status === 401 || err.response?.status === 400 || err.response?.status === 403) {
        setError("Email ou mot de passe incorrect.");
      } else {
        setError("Une erreur serveur est survenue.");
      }
    } finally {
      setLoading(false);
    }
  };


  return (
    <main>
      <section
        style={{ marginTop: '10rem' }}
        // className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        className="d-flex align-items-center mb-lg-5">
        <Container>
          <Row className="justify-content-center form-bg-image" style={{ backgroundImage: `url(${BgImage})` }}>
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center" style={{ marginBottom: '80px' }}>
                  <h2 className="mb-0">Admin Wemaza </h2>
                  <h4 className="mb-0">Veuillez vous connecter</h4>
                </div>


                <Form className="mt-4" onSubmit={handleLogin}>
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Ton email</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                      <Form.Control
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </InputGroup>
                  </Form.Group>

                  <Form.Group id="password" className="mb-4">
                    <Form.Label>Ton mot de passe</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <InputGroup.Text onClick={() => setShowPassword(!showPassword)} style={{ cursor: "pointer" }}>
                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>

                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <Form.Check type="checkbox">
                      <FormCheck.Input id="defaultCheck5" className="me-2" />
                      <FormCheck.Label htmlFor="defaultCheck5" className="mb-0">Se rappeler de moi</FormCheck.Label>
                    </Form.Check>

                  </div>

                  {error && (
                    <div
                      style={{
                        backgroundColor: '#f8d7da',
                        color: '#721c24',
                        padding: '10px 15px',
                        borderRadius: '5px',
                        border: '1px solid #f5c6cb',
                        textAlign: 'center',
                        marginBottom: '16px',
                      }}
                    >
                      {error}
                    </div>
                  )}


                  <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                    {loading ? "Connexion..." : "CONNEXION"}
                  </Button>
                </Form>


                {/* <div className="d-flex justify-content-center align-items-center mt-4">
                  <span className="fw-normal">
                    Pas encore inscrit ?{" "}
                    <Card.Link as={Link} to={Routes.Signup.path} className="fw-bold">
                      Créer un compte
                    </Card.Link>
                  </span>
                </div> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default Login;
